export default __webpack_public_path__ + "static/media/tennis-orange.694a6022.png";